import {
  AUTH_TOKEN,
  TOKEN_TYPE,
  LOGIN_USER_ID,
  IDENTIFIER,
  EXPIRES_IN,
  LOGIN_PEOPLE_COMPANY,
  LOGIN_USER_PEOPLE,
  IS_B2B,
  IS_CALL_CENTER,
  IS_CUSTOMER,
  IS_EMPLOYEE,
  LOGIN_PEOPLE_DETAIL,
  LOGIN_NAME,
  LOGIN_PHONE_PREFIX,
  LOGIN_PHONE,
  LOGIN_SOCIAL,
  SOCIAL_TOKEN,
  B2B_ClASS_TYPE,
  ARRANGER_PEOPLE_ID,
  LOGIN_USER_DATA,
  ARR_PARTNERSHIP_OBJ,
  ADDRESSBOOK_ID,
  LOGIN_TYPE,
} from "../config/constants";
import {
  ARRANGER_LIST_PAGE,
  CREATE_NEW_ARRANGER,
  EMPLOYEE_B2B_SEARCH,
  SET_AS_ARRANGER,
} from "../pages/employeepages/EmployeeConfig";
import { clearInterFlightResultCache } from "./interFlightResultCache";
import { clearFlightSearchCache } from "./flightResultCache";
import { resetEventTrackerData } from "./flightEventTracker";

export const removeFromLocalStorage = () => {
  window?.ma?.removeStorage({
    key: "access_token",
    success(res) {
      console.log(res, "remove login people detail");
    },
    fail(er) {
      console.log("fail login people detail", er);
    },
  });
  window?.ma?.removeStorage({
    key: "token_type",
    success(res) {
      console.log(res, "remove login people detail");
    },
    fail(er) {
      console.log("fail login people detail", er);
    },
  });
  localStorage.removeItem(AUTH_TOKEN);
  localStorage.removeItem(TOKEN_TYPE);
  localStorage.removeItem(EXPIRES_IN);
  localStorage.removeItem(IDENTIFIER);
  localStorage.removeItem(LOGIN_USER_ID);
  localStorage.removeItem(LOGIN_PEOPLE_COMPANY);
  localStorage.removeItem(LOGIN_USER_PEOPLE);
  localStorage.removeItem(IS_B2B);
  localStorage.removeItem(IS_CALL_CENTER);
  localStorage.removeItem(IS_CUSTOMER);
  localStorage.removeItem(IS_EMPLOYEE);
  localStorage.removeItem(LOGIN_PEOPLE_DETAIL);
  localStorage.removeItem(LOGIN_NAME);
  localStorage.removeItem(LOGIN_PHONE_PREFIX);
  localStorage.removeItem(LOGIN_PHONE);
  localStorage.removeItem(LOGIN_SOCIAL);
  localStorage.removeItem(SOCIAL_TOKEN);
  localStorage.removeItem(B2B_ClASS_TYPE);
  localStorage.removeItem(ARRANGER_PEOPLE_ID);
  localStorage.removeItem(LOGIN_USER_DATA);
  localStorage.removeItem("companyPayment");
  localStorage.removeItem(SET_AS_ARRANGER);
  localStorage.removeItem(EMPLOYEE_B2B_SEARCH);
  localStorage.removeItem(ARRANGER_LIST_PAGE);
  localStorage.removeItem(CREATE_NEW_ARRANGER);
  localStorage.removeItem("access");
  localStorage.removeItem("accessType");
  localStorage.removeItem("passengerAddressBookId");
  localStorage.removeItem(ARR_PARTNERSHIP_OBJ);
  localStorage.removeItem("arrangerLoyaltyData");

  // Cached fares belong to whoever was signed in. The search keys carry the
  // role (guest / b2b / call centre / class type) but no user identity, so two
  // B2C travellers on the same device and the same search share a key - the
  // second would be served the first's cached results. Logging out is an
  // identity change, so the identity-scoped caches go with it.
  //
  // Clearing the shared IndexedDB store is right *here* specifically: auth
  // lives in localStorage, so a logout is global to every tab anyway. That is
  // not true of starting a search, which is why the home page no longer wipes
  // it (see FlightResultRedirect).
  // --- Identity and contact details -------------------------------------
  // These outlived logout while the keys above were being cleared carefully.
  // strData is the worst of them: a verbatim copy of LOGIN_PEOPLE_DETAIL under
  // a name the original clean-up never knew about.
  localStorage.removeItem("strData");
  localStorage.removeItem("device_id_email");
  localStorage.removeItem("device_id_full_phone");
  localStorage.removeItem("profileId");
  localStorage.removeItem("b2bId");
  localStorage.removeItem("miniappinfo");
  localStorage.removeItem("arranger_id_lead");
  localStorage.removeItem(ADDRESSBOOK_ID);
  localStorage.removeItem(LOGIN_TYPE);
  // Support chat context - carries whatever the traveller told Gorgias.
  localStorage.removeItem("gorgiasHomeInfo");
  localStorage.removeItem("searchGorgiasInfo");
  // Reset rather than remove: the tracker expects its key to exist, and
  // resetEventTrackerData puts back the guest shape without the user on it.
  resetEventTrackerData();

  // --- Booking scoped ----------------------------------------------------
  // One traveller's trip in progress must not be handed to the next person on
  // the device. recentSearches is deliberately left: it is a device
  // convenience rather than booking data, and dropping it is a product call.
  localStorage.removeItem("selectedInfoArr");
  // The PNR of the booking just made - written by reservationHook.createPnr.
  localStorage.removeItem("pnr");
  localStorage.removeItem("promo_reservationId");
  localStorage.removeItem("insuranceForm");
  localStorage.removeItem("insuranceTravelInfo");
  localStorage.removeItem("insuranceReservationId");
  localStorage.removeItem("insuranceProductId");

  // --- sessionStorage ----------------------------------------------------
  // Logout cleared none of this before. removePassengerInfo already knew the
  // right keys for the passenger/reservation set; it was simply never called
  // from here, only from MainPage and PaymentPage.
  removePassengerInfo();
  try {
    // Deliberately NOT clearing LOGIN_VIA_KBZPAY (kbz_user_data). That is the
    // mini-app's ambient wallet identity, populated by KBZPayConsentHook from a
    // query plus a reload - not a Flymya credential. Dropping it would leave a
    // KBZ mini-app user unable to re-login via KBZPay without reloading, and it
    // buys little: sessionStorage is per tab and dies with it anyway.
    sessionStorage.removeItem("createPeopleId");
    sessionStorage.removeItem("search_again_values");
    sessionStorage.removeItem("updateArrangerEmail");
    sessionStorage.removeItem("updateArrangerPhone");
    sessionStorage.removeItem("isArrangerEmailSaved");
    sessionStorage.removeItem("isArrangerPhoneSaved");
    sessionStorage.removeItem("firstTimeArranger");
  } catch (err) {
    // storage unavailable - nothing else to do
  }

  clearFlightSearchCache();
  // Returned, not fired and forgotten: callers that follow this with a hard
  // navigation have to wait for it - see logoutThenNavigate.
  return clearInterFlightResultCache().catch(() => {});
};

// Longest a logout may wait for the cache wipe before navigating anyway. A
// logout that never leaves the page is worse than one that leaves a row behind.
const CACHE_CLEAR_TIMEOUT = 500;

/**
 * Logout followed by a full page load.
 *
 * `clearInterFlightResultCache` is an IndexedDB transaction, and assigning
 * `window.location.href` unloads the page - which aborts it mid-flight and can
 * leave the previous user's cached fares in a store the next one reads. So the
 * navigation waits for the wipe, or for CACHE_CLEAR_TIMEOUT, whichever lands
 * first. Paths that navigate through React Router instead do not unload the
 * page and can call removeFromLocalStorage directly.
 */
export const logoutThenNavigate = (destination) => {
  const go = () => {
    window.location.href = destination;
  };

  Promise.race([
    removeFromLocalStorage(),
    new Promise((resolve) => setTimeout(resolve, CACHE_CLEAR_TIMEOUT)),
  ]).then(go, go);
};

export const removePassengerInfo = () => {
  sessionStorage.removeItem("adultpassenger");
  sessionStorage.removeItem("childpassenger");
  sessionStorage.removeItem("infantpassenger");
  sessionStorage.removeItem("contactInfo");
  sessionStorage.removeItem("resId");
  sessionStorage.removeItem("resData");
  sessionStorage.removeItem("pnrFailDept");
  sessionStorage.removeItem("pnrFailReturn");
  sessionStorage.removeItem("PNRfailCount");
  sessionStorage.removeItem("PNRfailReturnCount");
};
